import React from 'react';
import { FaFilePdf, FaImage, FaTimes, FaSpinner } from 'react-icons/fa';
import { PendingAttachment } from '../../hooks/useTeamChatSocket';

interface ChatAttachmentPreviewProps {
  attachments: PendingAttachment[];
  onRemove: (clientId: string) => void;
}

/** Staged attachments shown above the composer before sending */
const ChatAttachmentPreview: React.FC<ChatAttachmentPreviewProps> = ({
  attachments,
  onRemove,
}) => {
  if (attachments.length === 0) return null;

  return (
    <div className="chat-attachment-previews">
      {attachments.map((attachment) => (
        <div
          key={attachment.clientId}
          className={`chat-attachment-preview ${attachment.status === 'error' ? 'chat-attachment-preview-error' : ''}`}
          title={attachment.error || attachment.filename}>
          {attachment.status === 'uploading' ? (
            <FaSpinner className="chat-attachment-spinner" />
          ) : attachment.mimeType === 'application/pdf' ? (
            <FaFilePdf />
          ) : (
            <FaImage />
          )}
          <span className="chat-attachment-name">{attachment.filename}</span>
          {attachment.status === 'error' && (
            <span className="chat-attachment-error-text">
              {attachment.error}
            </span>
          )}
          <button
            className="chat-attachment-remove"
            onClick={() => onRemove(attachment.clientId)}
            title="Remove attachment">
            <FaTimes size={10} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ChatAttachmentPreview;
